module.exports = __webpack_public_path__ + "img/syt.5e4f1fb8.png";